import { apiClient } from '../lib/api/client';
import type { OnboardingStatus } from '../models/v2/onboarding';

export const onboardingService = {
    getStatus: async (): Promise<OnboardingStatus> => {
        // Current backend route: /api/onboarding/status
        // apiClient handles base URL
        const response = await apiClient.get<OnboardingStatus>('/api/onboarding/status');
        return response;
    }
};
